import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { BehaviorSubject, Observable, filter, firstValueFrom } from 'rxjs';
import { isNil } from 'lodash';
import { RedirectProvider } from './redirect.provider';

@Injectable()
export class DoenKidsAuth0Provider {
  public ready$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public currentSession$: BehaviorSubject<any> = new BehaviorSubject(undefined);

  private _accessToken$ = new BehaviorSubject<string | null>(null);

  public accessToken$: Observable<string>;

  public isAuthenticated$: Observable<boolean>;

  constructor(
    private $auth: AuthService,
    private $redirect: RedirectProvider,
  ) {
    this.$auth.user$.subscribe((userProfile) => {
      console.log('[AUTH0-PROVIDER] New User Profile', userProfile);
      this.currentSession$.next(userProfile);
      if (userProfile) {
        firstValueFrom(this.$auth.getAccessTokenSilently())
          .then((accessToken) => {
            console.log('[AUTH0-PROVIDER] Retrieved access token', accessToken);
            this._accessToken$.next(accessToken);
          })
          .catch((error) => {
            console.error('[AUTH0-PROVIDER] Error fetching access token', error);
          })
          .finally(() => {
            this.ready$.next(true);
          });
      } else {
        this.ready$.next(true);
      }
    });

    this.accessToken$ = this._accessToken$.pipe(
      filter((token) => !isNil(token)),
    );

    this.isAuthenticated$ = this.$auth.isAuthenticated$;
  }

  login() {
    const redirectTo = this.$redirect.getPathToRedirectTo();
    this.$redirect.clearPathToRedirectTo();
    this.$auth.loginWithRedirect({
      appState: {
        target: redirectTo,
      },
    });
  }

  accessToken() {
    return this._accessToken$.value;
  }

  logout() {
    this.$auth.logout({
      logoutParams: {
        returnTo: document.location.origin,
      },
    });
  }

  // This profile method is important for both the auth-guard and the login page
  // to determine if the user is authenticated and navigation should occur
  // It has the special behavior of waiting for the Auth0 provider to be ready
  //
  async profile() {
    await firstValueFrom(this.ready$.pipe(filter((isReady) => !!isReady)));
    return this.currentSession$.value;
  }
}
